// dependecies import ==>
import React from "react";
// assets and scss import ==>
import "./checkboxWithText.scss";
import tick from "../../../../assets/tick.svg";
import FocusableDiv from "../../FocusableDiv";

const CheckboxWithText = (props) => {
  const { label, disabled, selected, handleChange } = props;

  // Create UI ==>

  const displayCheckboxWithText = () => {
    return (
      <div className="checkbox-with-text-container">
        <FocusableDiv
          className={
            "checkbox-with-text-input-box " +
            (selected ? "checkbox-with-text-input-box-selected" : "")
          }
          onClick={(e) => {
            e.stopPropagation();
            if (!disabled) {
              handleChange();
            }
          }}
          style={{ cursor: disabled ? "not-allowed" : "pointer" }}
        >
          {selected && <img src={tick} alt="" />}
        </FocusableDiv>
        <div className="checkbox-with-text-label">{label}</div>
      </div>
    );
  };

  // <===

  return <>{displayCheckboxWithText()}</>;
};

export default CheckboxWithText;
